export const AdditionalIcon = (AdditionalIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
}>, style?: React.CSSProperties, className?: string, secondary?: boolean, primary?: boolean) => {
    let fill = "none";
    if(secondary) fill = "#F29939";
    if(primary) fill = "#FAFAFA";

    if (AdditionalIcon) return (<AdditionalIcon fill={fill} className={className} style={style}></AdditionalIcon>);
    return;
}